import { SetupFooter } from 'components/SetupFooter'
import { SetupLayout } from 'components/SetupLayout'
import { Upload } from 'components/Upload/Upload'
import { requireAuth, useAuth } from 'util/auth'
import { useSetupStore } from '../../hooks/useSetupStore'
import { useListProjects } from 'hooks/projects'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { toast } from 'react-hot-toast'
import { useUpdateUser } from 'hooks/users'
import { useProjectStore } from 'store/useProjectStore'

function FirstUpload() {
  const { project, setProject } = useSetupStore()
  const router = useRouter()
  const { data: dbProject, refetch: refetchProjects } = useListProjects()
  const auth = useAuth()
  const { mutateAsync: updateUser } = useUpdateUser()
  const { setShowTrialStartedModal } = useProjectStore()

  useEffect(() => {
    if (dbProject?.items.length && !project) {
      setProject(dbProject.items[0])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dbProject])

  const handleUpload = async (data: any) => {
    try {
      await updateUser({
        userId: auth.user ? auth.user.id : '',
        data: {
          hasCompletedSetup: true,
          hasUploadedFirstFile: true,
        },
      })

      toast.success(
        'Success! Please give us a moment as we process your upload.'
      )
      await refetchProjects()
      // go to the first project
      router.push(`/projects/${dbProject?.items[0]?.id}`)
      // setShowTrialStartedModal
      setShowTrialStartedModal(true)
    } catch (error) {
      toast.error('Error uploading file')
    }
  }

  return (
    <SetupLayout>
      <Upload projectId={project?.id} onUpload={handleUpload} />
      <SetupFooter
        title="How can I get the best results from Outcast?"
        items={[
          'Files longer than 10 minutes work best.',
          'Outcast boasts the highest quality transcription rates in the industry.',
        ]}
      />
    </SetupLayout>
  )
}

export default requireAuth(FirstUpload)
